import { authAPI } from './api';

export const authService = {
  // 登录 - 邮箱登录模式
  login: async (email, password) => {
    const response = await authAPI.login({
      email,
      password
    });
    return response.data;
  },

  // 登出
  logout: async () => {
    const response = await authAPI.logout();
    return response.data;
  },

  // 获取用户信息
  getProfile: async () => {
    const response = await authAPI.profile();
    return response.data;
  },

  // 获取租户列表
  getTenants: async () => {
    const response = await authAPI.tenants();
    return response.data;
  },

  // 注册用户
  register: async (data) => {
    const response = await authAPI.register(data);
    return response.data;
  },

  // 检查登录状态
  isAuthenticated: () => {
    const token = localStorage.getItem('auth_token');
    return !!token;
  },

  // 获取认证token
  getToken: () => {
    return localStorage.getItem('auth_token');
  },

  // 获取当前用户
  getCurrentUser: () => {
    const userStr = localStorage.getItem('auth_user');
    if (userStr) {
      try {
        return JSON.parse(userStr);
      } catch (error) {
        return null;
      }
    }
    return null;
  },

  // 获取当前租户
  getCurrentTenant: () => {
    const tenantStr = localStorage.getItem('auth_tenant');
    if (tenantStr) {
      try {
        return JSON.parse(tenantStr);
      } catch (error) {
        return null;
      }
    }
    return null;
  },

  // 检查用户角色
  hasRole: (role) => {
    const user = authService.getCurrentUser();
    return user && user.role === role;
  },

  // 检查用户权限
  hasPermission: (requiredRole) => {
    const user = authService.getCurrentUser();
    if (!user) return false;
    
    // 简单的角色层级：admin > manager > user
    const roleHierarchy = {
      'admin': 3,
      'manager': 2,
      'user': 1
    };
    
    const userRoleLevel = roleHierarchy[user.role] || 0;
    const requiredRoleLevel = roleHierarchy[requiredRole] || 0;
    
    return userRoleLevel >= requiredRoleLevel;
  },

  // 更新本地存储的用户信息
  updateLocalUser: (userData) => {
    localStorage.setItem('auth_user', JSON.stringify(userData));
  },

  // 更新本地存储的租户信息
  updateLocalTenant: (tenantData) => {
    localStorage.setItem('auth_tenant', JSON.stringify(tenantData));
  }
};